<template>
    <div>
        <span v-html="$_.get(activity, 'payload.message')"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "CustomActivity",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
